import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=70544453&scoped=true&"
import script from "./Unauthorized.vue?vue&type=script&lang=ts&"
export * from "./Unauthorized.vue?vue&type=script&lang=ts&"
import style0 from "./Unauthorized.vue?vue&type=style&index=0&id=70544453&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70544453",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VCard,VContainer,VFlex,VLayout,VMain})
